import c from 'clsx';
import { LoadingSpinnerIcon, PlayIcon, PauseIcon } from './icons';

export function PlayPauseButton(props: {
    loading: boolean;
    playing: boolean;
    onClick: () => void;
}) {
    const icon = props.loading ? (
        <LoadingSpinnerIcon />
    ) : props.playing ? (
        <PauseIcon />
    ) : (
        <PlayIcon />
    );

    return (
        <div
            onClick={props.onClick}
            class={c(
                'cursor-pointer will-change-transform transition-transform duration-200 ease-in-out hover:transform-gpu hover:scale-110',
            )}
        >
            {icon}
        </div>
    );
}
